export const showCaseContent = {
	ocupation: 'Desenvolvedor Front End',
};
